import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html, unsafeStatic } from "lit/static-html.js";
import EkoElement from "@/utilities/element";
import { getSafeTag, type Tag } from "@/utilities/html";
import style from "./list.css?inline";
import "@/components/icon";

@customElement("eko-list")
class List extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) bullet = false;
  @property({ reflect: true }) icon?: string;
  @property({ reflect: true }) size?: "sm" | "md" | "lg" = "md";
  @property({ reflect: true }) type?: "ul" | "ol"; // default is `ul`

  render() {
    return html`
      <${unsafeStatic(this.tag)}
        class="eko-list"
        part="root"
      >
        <slot></slot>
      </${unsafeStatic(this.tag)}>
    `;
  }

  private get tag(): Tag {
    return getSafeTag(this.type, "ul");
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-list": List;
  }
}

export default List;
